import React from 'react';
import { useIntl } from 'react-intl';

import FormSelect from '../components/FormSelect';

type FormSelectRCFormContainerProps = React.ComponentProps<typeof FormSelect> & {
    form: {
        getFieldError: (...arg: unknown[]) => string[];
        getFieldDecorator: (
            key: string,
            ...arg: unknown[]
        ) => (node: React.ReactElement) => React.ReactElement;
    };
    additionalRules?: unknown[];
    initialValue: string;
    isRequired: boolean;
    preserve?: boolean;
    fullWidth?: boolean;
    validateTrigger?: string | 'onChange';
};

const FormSelectRCFormContainer = ({
    form,
    formItemKey,
    initialValue,
    label,
    placeholder,
    additionalRules = [],
    isRequired = false,
    optionList = [],
    optionListIsLoading = false,
    validateTrigger = 'onChange',
    preserve = true,
    fullWidth = false
}: FormSelectRCFormContainerProps): React.ReactElement => {
    const { formatMessage } = useIntl();

    const { getFieldDecorator } = form;
    const errors = form.getFieldError(formItemKey);
    return getFieldDecorator(formItemKey, {
        initialValue,
        validateTrigger,
        preserve,
        rules: [
            {
                required: isRequired,
                message: formatMessage({ id: 'Form.field.isRequired' }),
            },
            ...(additionalRules && additionalRules.length > 0 ? additionalRules : []),
        ],
    })(
        <FormSelect
            label={label}
            formItemKey={formItemKey}
            placeholder={placeholder}
            optionList={optionList}
            optionListIsLoading={optionListIsLoading}
            fullWidth={fullWidth}
            errors={errors}
        />
    );
};

export default FormSelectRCFormContainer;
